<!-- use select of store -->
<div class="spinner-container" *ngIf="spinnerActive$ | async">
  <mat-spinner></mat-spinner>
</div>

<router-outlet></router-outlet>

<span class="iren-console-version">v4.9.0</span>
